import Type from "@/model/types/Type";

const type = {

    PRODUCT: 1,
    RAW_MATERIAL: 2,
    COMPONENT: 3,

}

const list = [
    {
        value: type.PRODUCT,
        text: "Produto",
    },
    {
        value: type.RAW_MATERIAL,
        text: "Matéria-Prima",
    },
    {
        value: type.COMPONENT,
        text: "Componente",
    },
]

const contains = function (type) {
    return Type.contains(list, type)
}

const getText = function (type) {
    return Type.getText(list, type)
}


export default {
    type,
    list,
    contains,
    getText,
}


